import React from "react";
import styled from "styled-components";
import Price from "@arcteryx/components-price";
import { Body4Styles, Body6 } from "@arcteryx/components-typography";

const StyledPrice = styled(Price)`
  ${Body4Styles}
`;
const CartLine = styled.div`
  display: flex;
  justify-content: space-between;
  &:last-of-type {
    margin-bottom: 2em;
  }
`;
const TaxList = props => {
  const taxList = props?.taxes?.map(tax => (
    <CartLine key={tax.label}>
      <Body6 tag="span">{tax.label}:</Body6>
      <StyledPrice price={tax.amount} currency={tax.currency}>
        {tax.amount}
      </StyledPrice>
    </CartLine>
  ));
  return <>{taxList}</>;
};

export default TaxList;
